<template>
      <div class="productSpecsCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'productSpecs', params: {} }">
          Product Specs
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'productSpecsCreate', params: {} }">
            Create Product Specs
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Product Specs</v-card-title>
          <v-card-text>
            <productSpecs-form :productId="productId"></productSpecs-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import ProductSpecsForm from './ProductSpecsForm.vue';

    export default {
      name: 'productSpecs',
      components: {
        ProductSpecsForm
      },
      data: () => {
        return {
          productId: null
        }
      },
      created() {
        this.productId = this.$route.params.productId;
        this.$emit("showParent", false);
      }
    }
    </script>
    